import 'intersection-observer'
import React, { Fragment, useEffect, useState, useRef, useCallback } from 'react'
import { injectIntl, FormattedDate } from 'react-intl'
import { Grid, Avatar, Paper, Typography, Button, List, ListItem, CircularProgress } from '@material-ui/core'
import { blue } from '@material-ui/core/colors';
import { compose } from 'recompose'
import { connect, useDispatch } from 'react-redux'
import AssignmentIcon from '@material-ui/icons/Assignment';
import AssignmentTurnedInIcon from '@material-ui/icons/AssignmentTurnedIn';
import AttachmentIcon from '@material-ui/icons/Attachment';
import TimelineIcon from '@material-ui/icons/Timeline';
import CropOriginalIcon from '@material-ui/icons/CropOriginal';
import defaultImage from '../../../../assets/dashboard/results.jpg'
import { makeStyles } from '@material-ui/styles'
import { useTheme } from '@material-ui/core/styles'
import history from '../../../../utilties/history'
import { getPatientUpdates, markPatientUpdateAsRead } from '../../../../redux/actions'
import { caseIdSelector, patientUpdatesSelector, patientUpdatesAreLoadingSelector, wereAllPatientUpdatesLoadedSelector } from '../../../../redux/selectors'
import allUpdatesImage from '../../../../assets/images/empty-updates.svg'

const useStyles = makeStyles((theme) => ({
    root: {
        margin: '0 auto 2em auto',
        background: '#FFFFFF',
		boxShadow: '0 5px 10px rgba(0,0,0,0.09), 0 3px 3px rgba(0,0,0,0.13)',
		borderRadius: '8px',
		padding: '16px',
        '& ::-webkit-scrollbar': {
            width: 0,
            background: 'transparent'
        }
    },
    emptyState: {
        margin: '0 10px'
    },
    listItem: {
        borderTop: '1px solid #9CA9BE',
        position: 'initial',
        "&:hover": {
            backgroundColor: '#ecf5ff',
        },
        "&:focus": {
            backgroundColor: '#ecf5ff',
            outline: '2px solid #000',
        },
    },
    listItemRead: {
        backgroundColor: '#F9F9FF',
    },
    listBottom: {
        padding: '20px',
        textAlign: 'center',
        "&.load-more:hover": {
            backgroundColor: '#ecf5ff',
            cursor: 'pointer'
        }
    },
    messageState: {
        display: 'none',
        justifyContent: 'center',
        width: '44px',
        padding: '24px 16px 0 20px'
    },
    messagePic: {
        display: 'flex',
        paddingRight: '32px',
        paddingLeft: '16px',
        width: '104px'
    },
    picAvatar: {
        boxShadow: '0px 4px 12px #bbb',
        border: '1px solid #F9F9FF',
        '& svg': {
            transform: 'scale(1.6)'
        },
        width: theme.spacing(7),
        height: theme.spacing(7),
        color: theme.palette.getContrastText(theme.palette.common.white),
        backgroundColor: theme.palette.common.white,
        [theme.breakpoints.down('sm')]: {
            width: '45px',
            height: '45px',
            marginRight: '10px'
        }
    },
    messageBody: {
        display: 'flex',
        flexDirection: 'column',
        width: 'calc(100% - 150px - 104px)',
        '& p': {
            fontSize: '16px',
        },
    },
    dateActions: {
        width: '150px',
        color: '#000',
        position: 'relative',
        fontSize: '14px',
        textAlign: 'center',
    },
    infoMessage: {
        width: '100%',
        padding: '9px 10px 11px 12px',
        borderRadius: '0 16px 16px 16px',
        color: '#11121C',
        "& p": {
            margin: '0',
            fontSize: '16px',
            color: '#11121C'
        }
    },
    infoMessageRead: {
        backgroundColor: '#E2E3EA',
        color: '#11121C',
        "& p": {
            margin: '0',
            fontSize: '16px',
            color: '#11121C'
        }
    },
    infoMessageUnread: {
        fontSize: '16px',
        backgroundColor: blue[700],
        color: theme.palette.getContrastText(blue[700]),
        "& p": {
            margin: '0',
            fontSize: '16px',
            color: theme.palette.getContrastText(blue[700])
        }
    },
    listItemMessageRead: {
        backgroundColor: '#F9F9FF',
    },
    messageInsideUnread: {
        fontWeight: 'bold',
        color: '#11121C',
        fontSize: '16px'
    },
    messageInsideRead: {
        color: '#11121C',
        fontSize: '16px'
    },
    desktopView: {
        display: 'block',
        width: '100%',
        [theme.breakpoints.down('sm')]: {
            display: 'none',
		},
    },
    mobileView: {
        display: 'none',
        [theme.breakpoints.down('sm')]: {
            display: 'block',
            width: '100%',
            position: 'relative'
		},
    },
    mobileListItem: {
        display: 'flex',
        width: '100%',
        flexWrap: 'wrap',
        position: 'relative'
    },
    mobileDateActions: {
        textAlign: 'right',
        display: 'flex',
        justifyContent: 'space-between', 
        alignItems: 'center',
        flexGrow: '100',
        fontSize: '14px',
        "& .dashboardDateWrapper": {
            whiteSpace: 'nowrap',
            margin: '0 0 0 5px',
        },
        "& .dashboardDateWrapperButton button": {
            margin: '0',
            minWidth: '0'
        }
    },
    mobileMessageHeader: {
        display: 'flex',
        alignItems: 'center',
        width: '100%'
    },
    mobileMessageBody: {
        marginTop: '15px',
        display: 'flex',
        width: '100%',
        fontSize: '16px',
        "& .messageToPatientHeader": {
            marginBottom: '5px',
        },
        "& .messageToPatientText": {
            marginTop: '5px',
        }
    },
    mobileMessageBodyInner: {
        marginTop: '15px',
        width: '100%',
        "& div[class*='infoMessageRead']": {
            marginTop: '22px',
            position: 'relative',
            "&::before": {
                content: `''`,
                display: 'block',
                position: 'absolute',
                top: '-15px',
                left: '-2px',
                width: '10px',
                height: '10px',
                backgroundColor: '#F9F9FF',
            }
        },
    },
    updatesTitle: {
        paddingLeft: '16px', 
        paddingTop: '8px',
        [theme.breakpoints.down('sm')]: {
            paddingLeft: '0', 
            paddingTop: '0',
		},
    }
}))

const renderIcon = (icon, classes) => {
    return (<Avatar className={classes}>{icon}</Avatar>)
}

const renderAvatar = (item, classes) => {
    return (<Avatar className={classes} alt={item.userFullName} src={item.userImageUrl} />)
}

const renderDateActions = (date, theme, intl, showButton, buttonTextKey, clickHandler) => {

    return (
        <Fragment>
            <div
                data-testid="dashboard-date"
                className={'dashboardDateWrapper'}>
                <FormattedDate value={date} year="numeric" month="long" day="2-digit" />
            </div>
            {
                showButton &&
                <div data-print="none" className={'dashboardDateWrapperButton'}>
                    <Button
                        data-testid="more-details"
                        variant='contained'
                        color='primary'
                        onClick={clickHandler}>
                            {intl.formatMessage({ id: buttonTextKey })}
                    </Button>
                </div>
            }
        </Fragment>
    )
}

const renderUpdate = (item, classes, theme, intl, markAsRead, showConsentModal) => {

    let stateColor;

    if (item.readUtc) {
        stateColor = '#11121C'
    }
    else if (item.type === 3 || item.type === 4) {
        // stateColor = '#F54336'
        stateColor = '#d33a2e'
    }
    else {
        // stateColor = '#00a48a'
        stateColor = '#007e6a'
        
    }

    let pic
    
    switch (item.type) {
        case 1: // CaseCreated
        case 2: // CaseClosed
        case 3: // SurveyDue
        case 4: // SurveyOverdue
        case 5: // SurveyCompleted
            pic = item.isSubItem ? renderAvatar(item, classes.picAvatar) : renderIcon(<AssignmentIcon />, classes.picAvatar);
            break;
        case 6: // NewImage
            pic = item.isSubItem ? renderAvatar(item, classes.picAvatar) : renderIcon(<CropOriginalIcon />, classes.picAvatar);
            break;
        case 7: // NewDocument
            pic = item.isSubItem ? renderAvatar(item, classes.picAvatar) : renderIcon(<AttachmentIcon />, classes.picAvatar);
            break;
        case 8: // NewScore
            pic = item.isSubItem ? renderAvatar(item, classes.picAvatar) : renderIcon(<TimelineIcon />, classes.picAvatar);
            break;
        case 9: // ConsentSigned
            pic = renderIcon(<AssignmentTurnedInIcon />, classes.picAvatar)
            break;
    }

    let clickable;

    switch (item.type) {
        case 3: // SurveyDue
        case 4: // SurveyOverdue
            clickable = !item.isSubItem && !item.surveyExpired && !item.surveyCompleted;
            break;
        case 6: // NewImage
        case 7: // NewDocument
        case 8: // NewScore
            clickable = !item.isSubItem
            break;
        case 9: // ConsentSigned
            clickable = true;
            break;
    }

    let redirectUrl

    switch (item.type) {
        case 3: // SurveyDue
        case 4: // SurveyOverdue
            redirectUrl = `/survey/${item.caseId}/${item.observationProtocolId}/${item.surveyInstanceId}/${item.surveyId}`;
            break;
        case 6: // NewImage
            redirectUrl = `/albums`;
            break;
        case 8: // NewScore
            redirectUrl = '/scores';
            break;
        case 9: // ConsentSigned
            redirectUrl = `/terms/${item.termId}`;
            break;
        default:
            break;
    }

    let messageBody = (
        <Fragment>
            <div>
                
                <Typography
                    data-testid="badge-new"
                    component='div'
                    style={{ margin: '0', color: stateColor, fontWeight: '700', fontSize: '18px' }}>
                    {!item.readUtc &&
                        <span style={{
                            // backgroundColor: '#00a48a', 
                            backgroundColor: '#007e6a',                             
                            color: '#fff', 
                            padding: '1px 6px 2px', 
                            fontWeight: 'bold', 
                            borderRadius: '4px', 
                            fontSize: '12px', textTransform: 'uppercase', 
                            margin: '4px 5px 0 0', float: 'left'
                        }}>{intl.formatMessage({
                            id: 'app.patientUpdates.tag.new'
                        })}</span>
                    }
                    {!item.readUtc &&
                        <span>&nbsp;</span>
                    }
                    {item.tag &&
                        <Typography variant="h3"
                            data-testid="title-of-message-to-patient"
                            style={{ display: 'inline', margin: '0', color: stateColor, fontWeight: '700', fontSize: '18px' }}>
                            {intl.formatMessage({ id: `app.patientUpdates.tag.${item.tag}` })}
                        </Typography>
                    }
                </Typography>
            </div>
            {
                item.isSubItem
                    ?
                    (
                        <div className={`${classes.infoMessage} ${item.readUtc ? classes.infoMessageRead : classes.infoMessageUnread}`}>
                            <Typography
                                className="messageToPatientHeader"
                                data-testid="text-message-to-patient"
                                variant='body1'>
                                {item.messages[0]}
                            </Typography>
                        </div>
                    )
                    : (
                        <div className="messageToPatientText">
                            <div>
                                {
                                    redirectUrl && clickable
                                        ?
                                        <Typography
                                            variant='body1'
                                            data-testid="link-message-to-patient"
                                                className={` ${item.readUtc ? classes.messageInsideRead : classes.messageInsideUnread}`}
                                                color="secondary"
                                                style={{ fontSize: '16px' }}>
                                                {item.messages[0]}
                                                {item.ids && item.ids.length > 1 && <span>&nbsp;{intl.formatMessage({ id: 'app.patientUpdates.message.moreItems' })}</span>}
                                            
                                        </Typography>
                                        :
                                        <Typography
                                            data-testid="info1-message-to-patient"
                                            className={` ${item.readUtc ? classes.messageInsideRead : classes.messageInsideUnread}`}
                                            variant='body1'>
                                            {item.messages[0]}
                                        </Typography>
                                }
                            </div>
                            {
                                item.messages[1] &&
                                <div>
                                    <Typography
                                        data-testid="info2-message-to-patient"
                                        className={` ${item.readUtc ? classes.messageInsideRead : classes.messageInsideUnread}`}
                                        variant='body1'
                                        style={{ margin: '0' }}>
                                        {item.messages[1]}
                                    </Typography>
                                </div>
                            }
                        </div>
                    )
            }
        </Fragment>
    )

    let buttonTextKey;

    switch (item.type) {
        case 3: // SurveyDue
        case 4: // SurveyOverdue
            buttonTextKey = 'app.patientUpdates.record.actions.open';
            break;
        default:
            buttonTextKey = 'app.patientUpdates.record.actions.view';
            break;
    }

    let dateValue;

    switch (item.type) {
        case 3: // SurveyDue
        case 4: // SurveyOverdue
        case 5: // SurveyCompleted
        case 6: // NewImage
        case 7: // NewDocument
        case 8: // NewScore
            dateValue = item.customCompletedDate || item.createDate;
            break;
        default:
            dateValue = item.createDate;
            break;
    }

    let dateActions;
    
    switch (item.type) {
        default:
            dateActions = renderDateActions(
                dateValue,
                theme,
                intl,
                clickable,
                buttonTextKey,
                redirectUrl ? () => history.push(redirectUrl) : null);
            break;
    }

    let clickOnRowAction;

    switch (item.type) {
        default:
            clickOnRowAction = () => {
                if (!item.readUtc)
                {
                    markAsRead(item.id, item.ids);
                }
            }
    }

    return (
        <ListItem
            key={`${item.id}_${item.isSubItem ? 1 : 0}_${item.readUtc ? 1 : 0}`}
            className={`${classes.listItem} ${item.readUtc ? classes.listItemRead : ''}`}
            tabindex="0" onClick={clickOnRowAction}
            onKeyUp={(event) => {
                if (event.key == 'Enter') {
                    clickOnRowAction();
                }                    
            }}
        >            
            <div className={classes.desktopView}>
                    <Grid data-testid="patient-updates-item" container style={{ margin: '10px 0' }} >
                        <Grid item data-testid='message-state' className={classes.messageState}>
                            <div style={{
                                height: '8px',
                                width: '8px',
                                backgroundColor: stateColor,
                                borderRadius: '50%'
                            }} />
                        </Grid>
                        <Grid item data-testid='message-pic' className={classes.messagePic}>
                            {pic}
                        </Grid>
                        <Grid item data-testid='message-body' className={classes.messageBody}>
                            {messageBody}
                        </Grid>
                        <Grid item data-testid='message-date-actions' className={classes.dateActions}>
                            {dateActions}
                        </Grid>
                    </Grid>
            </div>

            <div className={classes.mobileView}>
                    <Grid className={`${classes.mobileListItem} patient-updates-item`} data-testid="patient-updates-item" style={{ margin: '10px 0' }}>
                        <Grid item data-testid='message-pic' className={classes.mobileMessageHeader}>
                            <Grid item data-testid='message-pic' className={classes.mobileMessagePic}>
                                {pic}
                            </Grid>
                            <Grid item data-testid='message-date-actions' 
                                className={classes.mobileDateActions}
                                >
                                {dateActions}
                            </Grid>
                        </Grid>
                        <Grid item data-testid='message-body' className={classes.mobileMessageBody}>
                            <div className={"mobileMessageBodyInner"}>
                                {messageBody}
                            </div>
                        </Grid>
                    </Grid>
            </div>
        </ListItem>
    )
}

const PatientUpdates = ({ intl, updates, loadPatientUpdates, markAsRead, caseId, areLoading, showConsentModal, wereAllPatientUpdatesLoaded }) => {

    const classes = useStyles();
    const theme = useTheme()
    const loader = useRef(null);
    const [lastSeenRecordId, setLastSeenRecordId] = useState(null)
    const [lastVisible, setLastVisible] = useState(null)
    const [lastVisibleProcessed, setLastVisibleProcessed] = useState(null)
    const [updatesCount, setUpdatesCount] = useState(null)
    const [updatesCountProcessed, setUpdatesCountProcessed] = useState(null)

    const getLastSeenRecordId = u => u.reduce(function(p, v) {
        return (p.id < v.id ? p : v);
    }).id;

    const loadMoreHandler = () => {
        setLastSeenRecordId(getLastSeenRecordId(updates));
    }

    useEffect(
        () => {
            loadPatientUpdates(lastSeenRecordId)
        },
        [lastSeenRecordId]
    )

    useEffect(
        () => {
            setUpdatesCount(updates.length);
        },
        [updates]
    )

    useEffect(
        () => {
            if (//!areLoading &&
                !wereAllPatientUpdatesLoaded &&
                updatesCount && updatesCount !== updatesCountProcessed &&
                lastVisible && lastVisible !== lastVisibleProcessed
                    ) {

                setUpdatesCountProcessed(updatesCount)
                setLastVisibleProcessed(lastVisible)

                //console.log(
                //    '[GOOD] ',
                //    'lastSeenRecordId: ',
                //    lastSeenRecordId,
                //    ' areLoading: ',
                //    areLoading,
                //    ' wereAllPatientUpdatesLoaded: ',
                //    wereAllPatientUpdatesLoaded,
                //    ' updates.length: ',
                //    updates.length,
                //    ' lastVisible: ',
                //    lastVisible,
                //    ' lastVisibleProcessed: ',
                //    lastVisibleProcessed
                //);

                loadMoreHandler();
            }
            else {
                //console.log(
                //    '[BAD] ',
                //    'lastSeenRecordId: ',
                //    lastSeenRecordId,
                //    ' areLoading: ',
                //    areLoading,
                //    ' wereAllPatientUpdatesLoaded: ',
                //    wereAllPatientUpdatesLoaded,
                //    ' updates.length: ',
                //    updates.length,
                //    ' lastVisible: ',
                //    lastVisible,
                //    ' lastVisibleProcessed: ',
                //    lastVisibleProcessed
                //);
            }
        },
        [updatesCount, lastVisible]
    )

    const handleObserver = useCallback((entries) => {
        const target = entries[0];

        let utc = new Date().getTime();

        //console.log('isIntersecting check: ', utc)

        if (target.isIntersecting) {
            //console.log('isIntersecting: ', utc)
            setLastVisible(utc)
        }
    },
    []);

    useEffect(() => {
            const options = {
                root: null,
                rootMargin: '0px',
                threshold: 1.0,
                //trackVisibility: true,
                delay: 100
            }

        const observer = new IntersectionObserver(handleObserver, options);

            if (loader.current) observer.observe(loader.current);

            return () => { observer.disconnect() };
        },
        [handleObserver]);

    return (
        <Paper className={classes.root}>
            <div className={classes.updatesTitle}>
                <Typography data-testid="patient-updates-title"
                    variant='h2'
                    style={{
                        color: '#000',
                        fontSize: '21px',
                        textAlign: 'left',
                        fontWeight: 'bold'
                    }}>
                    {intl.formatMessage({ id: 'app.patientUpdates.title' })}
                </Typography>
                <div style={{ width: '49px', height: '1px', margin: '15px 0 25px', background: '#000' }} />
            </div>

            <div style={{ margin: "0 -16px" }} class="listScrollOuter" >
                <List style={{}}>
                    {
                        updates && updates.length > 0 && updates.map((update, index) => renderUpdate(update, classes, theme, intl, markAsRead, showConsentModal))
                    }
                </List>
                {
                    areLoading
                        ? (
                            <div className={classes.listBottom} data-testid="patient-updates-more">
                                <CircularProgress />
                            </div>
                        )
                        : (
                            wereAllPatientUpdatesLoaded
                                ?
                                <div className={classes.listBottom} data-testid="patient-updates-more">
                                    <img alt="Image All Updates Loaded" src={allUpdatesImage} style={{ margin: '0 0 10px' }}></img>
                                    <Typography
                                        variant='h3'
                                        style={{ margin: '0' }}>
                                        {intl.formatMessage({ id: updates && updates.length ? 'app.patientUpdates.list.bottomMessage' : 'app.patientUpdates.list.emptyMessage' })}
                                    </Typography>
                                </div>
                                :
                                <div ref={loader} className={`load-more ${classes.listBottom}`} data-testid="patient-updates-more" onClick={loadMoreHandler}>
                                    <Typography
                                        variant='h3'
                                        style={{ margin: '0' }}>
                                        {intl.formatMessage({ id: 'app.patientUpdates.list.loadMoreMessage' })}
                                    </Typography>
                                </div>
                        )
                }
            </div>
        </Paper>
    )
}

const mapStateToProps = (state) => ({
    caseId: caseIdSelector(state),
    updates: patientUpdatesSelector(state),
    areLoading: patientUpdatesAreLoadingSelector(state),
    wereAllPatientUpdatesLoaded: wereAllPatientUpdatesLoadedSelector(state)
})

const mapDispatchToProps = (dispatch) => ({
    loadPatientUpdates: (lastSeenRecordId) => dispatch(getPatientUpdates(lastSeenRecordId)),
    markAsRead: (id, ids) => dispatch(markPatientUpdateAsRead(id, ids))
})


const enhance = compose(connect(mapStateToProps, mapDispatchToProps), injectIntl)

export default enhance(PatientUpdates)
